import React from 'react';
import { FacebookLogo, InstagramLogo, LinkedinLogo } from "@phosphor-icons/react";
import Logo from '../images/HeroBanner.png'
import { scrollToSection } from '../helper/scrollFunction';

const Footer = () => {
  return (
    <footer 
        className=" text-white pb-10 font-popp modal-class">

        <hr className="border-t-2 border-secondary mb-4 pb-10 w-full" />
        <div className="flex md:justify-between px-6 flex-col md:flex-row items-start">

          {/* --------------------------- LOGO AND COPYRIGHT --------------------------- */}
          <div className="text-left  text-sm md:text-base pb-6 px-4 md:px-10 flex flex-col items-start gap-y-2 md:gap-y-4">
            <span className='text-lg'>
                <img src={Logo} alt="" className='w-18 h-10 mb-4'/>
            </span>
            <p>
                <span>&copy; 2023 </span>
                <span className="text-secondary text-lg px-2">Web Development Department </span>
            </p>
          </div>

          {/* ---------------------------- NAVIGSTION LINKS ---------------------------- */}
          <div class="flex flex-col w-64 bg-transparent p-4 py-0">
            <h2 class="text-gray-500 text-lg font-medium mb-2 md:mb-4">Navigate</h2>
            <a href="#"  onClick={() => scrollToSection('hero')} class="text-slate-400 hover:text-white text-sm pb-1 ">Home Page</a>
            <a href="#" onClick={() => scrollToSection('about')} class="text-slate-400 hover:text-white text-sm pb-1">About Us</a>
            <a href="#" onClick={() => scrollToSection('teams')} class="text-slate-400 hover:text-white text-sm pb-1">Teams</a>
            <a href="#" onClick={() => scrollToSection('join')} class="text-slate-400 hover:text-white text-sm pb-1">Join Us</a>
            <a href="#" onClick={() => scrollToSection('contact')} class="text-slate-400 hover:text-white text-sm pb-1">Contacts</a>
        </div>

           { /* ------------------------- CONTACT ICONS AND EMAIL ------------------------ */}
          <div className="flex flex-col gap-y-12">
              <div className="flex justify-center space-x-4 mt-4">
                <a target="_blank" href="">
                    <FacebookLogo size={30} color="#4be4c0" className='hover:fill-[#fff] hover:scale-110  transition duration-300 ease-in-out'/>
                </a>
                <a target="_blank" href="https://www.instagram.com/datascienceclub.vitc/?hl=en">
                    <InstagramLogo size={30} color="#4be4c0" className='hover:fill-[#fff] hover:scale-110  transition duration-300 ease-in-out' />
                </a>
                <a  target="_blank" href="https://www.linkedin.com/company/dscvitcc/mycompany/">
                    <LinkedinLogo size={30} color="#4be4c0" className='hover:fill-[#fff] hover:scale-110  transition duration-300 ease-in-out' />
                </a>
              </div>
              <div class="flex items-center justify-center pr-4 relative">
                <label for="email" class="block absolute -top-6 left-2 text-sm font-semibold text-gray-700">Join us Now</label>
                <input type="email" placeholder="Enter your Email" class="box-border bg-transparent border border-gray-300 rounded-l-lg px-4 py-2 md:w-64 w-56 max-[360px]:w-40 text-gray-500 transition duration-300 ease-in-out focus:outline-none focus:border-blue-500 hover:bg-gray-900 hover:border-gray-400" />
                <button class="text-left border-gray-300 bg-[#4be4c0] text-black rounded-r-lg px-4 py-2 transition duration-300 ease-in-out hover:bg-[#0fbdb0] transform hover:scale-105 h-[43px] text-sm font-normal w-28">Get Started</button>
                       </div>
          </div>
        


      </div>
    </footer>
  );
};

export default Footer;
